import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { IProps } from './models';

export const CommonWrapper: FC<IProps> = ({ children, className, minHeight, styles }) => {
    return (
        <div className={cn(styles.wrapper, className)} style={{ minHeight: `${minHeight}px` }}>
            {children}
        </div>
    );
};
